import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import {
  SignIn,
  // SignUp,
  Reset,
  ProductEdit,
  ProductList,
  ProductDetail,
  CartList,
  OrderConfirm,
  OrderHistory,
  OrderComplete,
  UserMyPage,
  CategoriesEdit,
  ShopsEdit,
  MakersEdit,
  UsersEdit,
  FavoriteList,
  DefaultEntrance,
} from "./pages";
import Auth from "./Auth";
import OrderingDepartmentMenu from "./pages/orderingDapertment/OrderingDepartmentMenu";
import OrderingBaseEdit from "./pages/orderingDapertment/base/OrderingBaseEdit";
import OrderingDepartmentEdit from "./pages/orderingDapertment/department/OrderingDepartmentEdit";
import OrderProcessing from "./pages/OrderProcessing";
import NoticeDetail from "./pages/notice/NoticeDetail";
import NoticeEdit from "./pages/notice/NoticeEdit";
import NoticeAdd from "./pages/notice/NoticeAdd";
import NoticeList from "./pages/notice/NoticeList";
import ProductSorting from "./pages/ProductSorting";
import ProductMenu from "./pages/ProductMenu";
// 旧URL(綴りミス /order/proceccing)からのリダイレクト。
// 検索条件フィルタが URL パラメータになったため、クエリ文字列を保ったまま
// 正しい綴りの新URLへ転送する(既存のブックマーク・共有リンクを壊さない)
const RedirectToOrderProcessing = () => {
  const location = useLocation();
  return <Redirect to={{ ...location, pathname: "/order/processing" }} />;
};

const routes = [
  // { path: "/signup", component: SignUp },
  { path: "/signin", component: SignIn },
  { path: "/signin/reset", component: Reset },
  { path: "/default", component: DefaultEntrance },
];

const authRoutes = [
  { path: "/", component: ProductList, exact: true },
  { path: "/product/:id", component: ProductDetail, exact: true },
  { path: "/product/menu", component: ProductMenu, exact: true },
  { path: "/product/sorting", component: ProductSorting, exact: true },
  { path: "/product/edit/:id?", component: ProductEdit, exact: true },
  { path: "/cart", component: CartList },
  { path: "/order/confirm", component: OrderConfirm },
  { path: "/order/complete", component: OrderComplete },
  { path: "/order/history", component: OrderHistory },
  { path: "/user/mypage", component: UserMyPage },
  { path: "/categories/edit", component: CategoriesEdit },
  { path: "/shops/edit", component: ShopsEdit },
  { path: "/makers/edit", component: MakersEdit },
  { path: "/users/edit", component: UsersEdit },
  { path: "/order/processing", component: OrderProcessing },
  // 旧URL(綴りミス)。上のリダイレクトで新URLへ転送する
  { path: "/order/proceccing", component: RedirectToOrderProcessing },
  { path: "/favorite", component: FavoriteList },
  { path: "/ordering-department/menu", component: OrderingDepartmentMenu },
  { path: "/ordering-department/base-edit", component: OrderingBaseEdit },
  { path: "/notice/detail/:slug?", component: NoticeDetail },
  { path: "/notice/edit/:slug?", component: NoticeEdit },
  { path: "/notice/new", component: NoticeAdd },
  { path: "/notice/list", component: NoticeList },
  {
    path: "/ordering-department/department-edit",
    component: OrderingDepartmentEdit,
  },
];
const useRouter = () => {
  return (
    // <Router>
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          exact
          path={route.path}
          component={route.component}
        />
      ))}
      <Auth>
        {authRoutes.map((route, index) => (
          <Route
            key={index}
            exact={route.exact}
            path={route.path}
            component={route.component}
          />
        ))}
      </Auth>
    </Switch>
    // </Router>
  );
};

export default useRouter;
